import { Card, Grid, Typography } from '@mui/material';
import { LicenseMetricsData } from '../../api/apis/OrgPricebookLicenseMetricsApi';
import { Svgs } from '../../assets/svg';
import { PricebookBundle } from '../../models/PricebookData';
import NumericStepper from '../../components/NumericStepper';

interface LicenseAtAGlanceProps {
  licenseMetrics: LicenseMetricsData;
  pricebookBundle: PricebookBundle;
  value: number;
  onChange: (value: number) => void;
}

const LicenseAtAGlance: React.FC<LicenseAtAGlanceProps> = ({ pricebookBundle }) => {
  const pricebookName = pricebookBundle.pricebook.pricebookName;

  const getPackageArt = () => {
    switch (pricebookName) {
      case 'GuidedChoice Advisory Service':
        return <Svgs.PackageGcAdviceMedium />;
      case '3Nickels Advice':
        return <Svgs.Package3nAdviceMedium />;
      case '3Nickels Free':
        return <Svgs.Package3nFreeMedium />;
      case 'Advice + 3NickelsU':
        return <Svgs.Package3nUMedium />;
    }
  };

  return (
    <Card color='primary' variant='ghost'>
      <Grid container alignItems='center'>
        <Grid size='grow' container alignItems='center'>
          <Grid px={2}>{getPackageArt()}</Grid>
          <Grid size='grow'>
            <Typography variant='p18Bold' color='secondary.main'>
              {pricebookName}
            </Typography>
          </Grid>
        </Grid>
        <Grid size={{ xs: 4 }} m={2} container justifyContent='flex-end'>
          <NumericStepper label='Total licenses' fieldName='licenseCount' />
        </Grid>
      </Grid>
    </Card>
  );
};

export default LicenseAtAGlance;
